/* eslint-disable jira/integration/test-id-by-folder-structure */
/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import Field from '@atlaskit/form/field';
import { useFormState } from '@atlaskit/form/use-form-state';
import { ErrorMessage } from '@atlaskit/form/messages';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import type { BoardCreateFormValues } from './BoardCreateFormValues.types.tsx';
import { fireBoardCreateErrorAnalytics } from './fireBoardCreateErrorAnalytics.tsx';
import {
	boardSourceFieldComponentMap,
	boardSourceFieldComponentMapOld,
} from './boardSourceFieldComponentMap.tsx';

const sourceValueEmptyError = defineMessage({
	id: 'software-board-create.modal.form.source-value-picker.source-value-empty-error',
	defaultMessage: 'Please select a value',
	description: 'Error message for when the source value is empty',
});

export const VALIDATION_ERROR_EMPTY = 'VALIDATION_ERROR_EMPTY';
export const SOURCE_VALUE_FIELD_NAME = 'sourceValue';

export const SourceValuePicker = (): React.JSX.Element | null => {
	const { formatMessage } = useIntl();
	const formState = useFormState<BoardCreateFormValues>();
	const sourceType: BoardCreateFormValues['sourceType'] | undefined = formState?.values.sourceType;

	if (!sourceType) {
		return null;
	}
	const boardSource = fg('jira-issue-terminology-update-m4')
		? boardSourceFieldComponentMap
		: boardSourceFieldComponentMapOld;
	const mappedSource = boardSource[sourceType];

	if (!mappedSource) {
		fireBoardCreateErrorAnalytics({
			error: new Error(`No source field component found for ${sourceType}`),
			id: 'unmappedSourceType',
		});

		return null;
	}

	const { component: PickerComponent, extraProps, label } = mappedSource;

	return (
		<Field<BoardCreateFormValues['sourceValue']>
			key={`sourceValue-${sourceType}`}
			name={SOURCE_VALUE_FIELD_NAME}
			label={formatMessage(label)}
			isRequired
		>
			{({ fieldProps, error }) => (
				<>
					<PickerComponent
						key={`sourceValue-${sourceType}-picker`}
						label={formatMessage(label)}
						{...fieldProps}
						{...extraProps}
					/>
					{error === VALIDATION_ERROR_EMPTY && (
						// eslint-disable-next-line jira/integration/test-id-by-folder-structure
						<ErrorMessage testId="software-board-create.ui.modal.form.source-value-picker.error">
							{formatMessage(sourceValueEmptyError)}
						</ErrorMessage>
					)}
				</>
			)}
		</Field>
	);
};
